<template>

    <div id="app" >
        <component :is="currentLayout" v-if="notOnMobile">

            <transition :name="transitionName">
                <router-view/>
            </transition>

        </component>

        <div v-else id="not_on_mobile">
            <LogoSight />
            <h1 class="title is-size-2">{{ $t('layouts.global.noMobileTitle') }}</h1>
            <br>
            <h3 class="subtitle is-size-4">{{ $t('layouts.global.noMobileContent') }}</h3>
        </div>
    </div>

</template>

<script>
    import LogoSight from '@/components/layouts/logoSight'
    import Axios from 'axios'


    const defaultLayout = "layoutGuest"

    export default {
        name: 'AppContainer',
        components: {
            LogoSight
        },
        data(){
            return {
                transitionName: 'page-anim-top',
                layoutWidth: window.innerWidth,
            }
        },
        
        mounted(){
            // setInterval(() => {
            //     Axios.get(this.$store.sharpApiBaseUrl + "profile/get_access").then(resp => {
            //         const account = resp.data
            //         localStorage.setItem('account', JSON.stringify(account))
            //     }).catch(err => {
            //         console.log("Get access error", err.response)
            //     })
            // }, 10000);
        },
        computed: {
            currentLayout() {
                return this.$route.meta.layout || defaultLayout
            },
            notOnMobile(){
                if(this.$router.currentRoute.name != 'SurveyNew'){
                    return this.layoutWidth > 1024
                }else{
                    return true
                }

            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        methods: {
            handleResize() {
                this.layoutWidth = window.innerWidth;

            }
        },
        watch: {
          '$route' (to, from) {
            const toIndex = to.meta.pageOrder
            const fromIndex = from.meta.pageOrder
            if (toIndex == fromIndex){
                const toSubIndex = to.meta.pageSubOrder
                const fromSubIndex = from.meta.pageSubOrder
                this.transitionName = toSubIndex < fromSubIndex ? 'page-anim-left' : 'page-anim-right'
            }else{
                this.transitionName = toIndex < fromIndex ? 'page-anim-bottom' : 'page-anim-top'
            }

          }
        }
    }
</script>

<style lang="scss">
#not_on_mobile{
    max-width: 480px;
    width: 100%;
    margin: auto;
    padding: 30px 10px;
    text-align: center;
    svg{
        width: 150px;
        fill: $info;
    }
}
</style>